import { render } from "./AddAlaUnePage.vue?vue&type=template&id=560c8b2d&ts=true"
import script from "./AddAlaUnePage.vue?vue&type=script&lang=ts"
export * from "./AddAlaUnePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__